import { COLORS } from '@btime/constants'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useModalData } from '../../../components/modals/ModalsContext'
import { usePlaceTypeName } from '../../../utils/helpers/placeTypes'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('editLinkTree')
  const data = useModalData()
  const isEditing = !!data.id
  const placeTypeName = usePlaceTypeName(data.data.placeType, !isEditing)
  return (
    <>
      <Title size="h4" color={COLORS.dark2} noMargin>
        {placeTypeName
          ? t(isEditing ? 'editingTitle' : 'creatingTitle', { name: placeTypeName })
          : t('creatingTitleAsset')}
      </Title>
      <Separator weight={6} />
    </>
  )
}

export default ModalHeader
